angular.module('angus.services').factory("stateProvinceResouce", [
    '$rootScope', '$resource', function ($rootScope, $resource) {
        return $resource("api/countries/:countryId/:childObject", { countryId: '@countryId', childObject: '@childObject' },
        {
            getStateProvinceForCountryId: { method: 'GET', childObject: 'stateProvince' }
        });
    }
])